var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-practice__media-player mt16" }, [
    _c(
      "div",
      {
        staticClass: "ote-media-player",
        class: _vm.tranStatus !== 2 ? "ote-file-transcodeing" : "",
      },
      [
        !_vm.needReload
          ? _c("yxtbiz-video", {
              ref: "player",
              attrs: {
                type: _vm.playerType,
                options: _vm.options,
                starttime: _vm.starttime,
                autoStart: _vm.autoStart,
                width: _vm.width,
                height: _vm.height,
                playRate: _vm.playRate,
                isShowWatermark: _vm.isShowWatermark,
                isNeedToken: _vm.isNeedToken,
                watermarkObj: _vm.watermark,
                isOpenMutiple: "",
              },
              on: {
                onBeforePlay: _vm.onBeforePlay,
                onReady: _vm.onReady,
                onPlay: _vm.onPlay,
                onPause: _vm.onPause,
                onComplete: _vm.onComplete,
                onError: _vm.onError,
                onFullscreen: _vm.onFullscreen,
                onSeek: _vm.onSeek,
                onTime: _vm.onTime,
                onQualityChange: _vm.onQualityChange,
                onPlaybackRate: _vm.onPlaybackRate,
              },
            })
          : _vm._e(),
        _vm.tranStatus !== 2
          ? _c(
              "div",
              { staticClass: "transcoding-tips" },
              [
                _vm.tranStatus === 3
                  ? _c("yxt-svg", {
                      attrs: {
                        width: "14",
                        height: "14",
                        "icon-class": "message-error",
                      },
                    })
                  : _c("yxt-svg", {
                      attrs: {
                        width: "14",
                        height: "14",
                        "icon-class": "message-error",
                      },
                    }),
                _c("span", { staticClass: "ml4" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        _vm.tranStatus === 3
                          ? "pc_biz_ote_lbl_objtranscodefail"
                          : "pc_biz_ote_lbl_objtranscoding",
                        [_vm.$t("pc_biz_ote_lbl_" + _vm.playerType)]
                      )
                    )
                  ),
                ]),
              ],
              1
            )
          : _vm._e(),
        _vm.$slots.action
          ? _c(
              "span",
              { staticClass: "player-action-button" },
              [_vm._t("action")],
              2
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }